var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnblock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M448,213.333h-42.667v-64C405.333,66.853,338.481,0,256,0S106.667,66.853,106.667,149.333 c0,11.782,9.551,21.333,21.333,21.333c11.782,0,21.333-9.551,21.333-21.333c0-58.917,47.75-106.667,106.667-106.667 s106.667,47.75,106.667,106.667v64H64c-11.782,0-21.333,9.551-21.333,21.333v256C42.667,502.449,52.218,512,64,512h384 c11.782,0,21.333-9.551,21.333-21.333v-256C469.333,222.885,459.782,213.333,448,213.333z M426.667,469.333H85.333V256h341.333 V469.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.842,277.333h-31.68c-26.603,0-48.171,21.556-48.171,48.149v53.035c0,26.593,21.568,48.149,48.171,48.149h31.68 c26.587,0,48.149-21.562,48.149-48.149v-53.035C319.991,298.895,298.43,277.333,271.842,277.333z M277.325,378.517 c0,3.023-2.459,5.483-5.483,5.483h-31.68c-3.044,0-5.504-2.459-5.504-5.483v-53.035c0-3.024,2.46-5.483,5.504-5.483h31.68 c3.023,0,5.483,2.459,5.483,5.483V378.517z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnblock);
export default __webpack_public_path__ + "static/media/unblock.98aa04c531229c308a738f511b99b586.svg";
export { ForwardRef as ReactComponent };